module.exports = __webpack_public_path__ + "static/img/8.faa6fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/common/medication/8.png
// module id = jTcE
// module chunks = 1